import React from 'react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('Application error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          maxWidth: '600px',
          margin: '80px auto',
          fontFamily: 'monospace',
          color: '#e0e0e0',
          backgroundColor: '#1e1e1e',
          borderRadius: '8px',
          border: '1px solid #333',
        }}>
          <h2 style={{ color: '#f44336' }}>Something went wrong</h2>
          <p style={{ color: '#aaa' }}>
            The application encountered an error. Please try refreshing the page.
          </p>
          <details style={{ marginTop: '16px' }}>
            <summary style={{ cursor: 'pointer', color: '#90caf9' }}>Error Details</summary>
            <pre style={{
              marginTop: '8px',
              padding: '12px',
              backgroundColor: '#121212',
              borderRadius: '4px',
              overflow: 'auto',
              fontSize: '12px',
              maxHeight: '300px',
            }}>
              {this.state.error && this.state.error.toString()}
              {'\n\n'}
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '16px',
              padding: '8px 24px',
              backgroundColor: '#90caf9',
              color: '#121212',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
